<template>
    <div class="form-body">
        <div v-show="loading != 0" class="row">
            <div class="col-sm-12">
                <h2>{{ trans('form.please_wait') }}...</h2>
                <ring-loader />
            </div>
        </div>
        <div v-show="loading == 0">
            <div class="row">
                <div class="col-sm-12">
                    <singleselect
                        v-model="bagItem.package"
                        name="package"
                        :title="trans('bag_item.entity.package')"
                        :options="packages"
                        :checked="bagItem.package"
                        :errors="form.options.errors"
                        label="name"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <singleselect
                        v-model="bagItem.variant"
                        name="variant"
                        :title="trans('bag_item.entity.variant')"
                        :options="variants"
                        :checked="bagItem.variant"
                        :errors="form.options.errors"
                        label="name"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <singleselect
                        v-model="bagItem.mealType"
                        name="mealType"
                        :title="trans('bag_item.entity.meal_type')"
                        :options="mealTypes"
                        :checked="bagItem.mealType"
                        :errors="form.options.errors"
                        show-route-name="meal_type_show"
                        label="name"
                        @dispatch="getSizes"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <singleselect
                        v-model="bagItem.size"
                        name="size"
                        :title="trans('bag_item.entity.size')"
                        :options="sizes"
                        :checked="bagItem.size"
                        :errors="form.options.errors"
                        label="name"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <singleselect
                        v-model="bagItem.status"
                        name="status"
                        :title="trans('bag_item.entity.status')"
                        :options="statuses"
                        :checked="bagItem.status"
                        :errors="form.options.errors"
                        label="value"
                        show-route-name="tag_show"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import toastr from '../toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

export default {
  components: {
    Singleselect,
    RingLoader,
  },
  props: {
    bagItemId: {
      type: [Number, String],
      default: null,
    },
    bag: {
      type: Object,
      default: null,
    },
    defaultBasketId: {
      type: [String, Number],
      default: null,
    },
    save: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: 0,
      packages: [],
      mealTypes: [],
      sizes: [],
      statuses: [],
      bagItem: {
        id: null,
        variant: null,
        package: null,
        mealType: null,
        size: null,
        status: null,
      },
      form: {
        options: {
          errors: {},
        },
      },
    }
  },
  computed: {
    variants() {
      if (this.bagItem.package === null) {
        return []
      }

      return this.packages.find(el => {
        if (el.id === this.bagItem.package) {
          return true
        }
      }).variants
    },
  },
  watch: {
    save: function (val) {
      if (val) {
        this.saveNewBagItem()
      }
    },
    'bagItem.mealType': function (newVal, oldVal) {
      if (newVal && oldVal) {
        this.bagItem.size = null
      }
    },
  },
  mounted: function () {
    this.getPackages()
    this.getMealTypes()
    this.getStatuses()
    this.getSizes()
  },
  methods: {
    getBagItem(id) {
      this.loading++

      let url = Routing.generate('api_get_bagitem', { id: id,
        context: 'bagitem_edit' })

      this.$http.get(url).then(
        response => {
          this.bagItem = response.data
          this.form.options.errors = {}
          this.loading--
          this.getSizes(this.bagItem.mealType)
        },
        response => {
          this.handleAjaxError(response)
          this.loading--
        }
      )
    },
    getPackages() {
      this.loading++

      let url = Routing.generate('api_get_packages', {
        context: 'bag_item_edit',
      })

      this.$http.get(url).then(
        response => {
          this.packages = response.data
          this.loading--
        },
        response => {
          this.handleAjaxError(response)
          this.loading--
        }
      )
    },
    getMealTypes() {
      this.loading++

      let url = Routing.generate('api_get_meal_types', {
        context: 'dropdown',
      })

      this.$http.get(url).then(
        response => {
          this.mealTypes = response.data
          this.loading--
        },
        response => {
          this.handleAjaxError(response)
          this.loading--
        }
      )
    },
    getSizes(value) {
      if (value) {
        this.loading++
        let url = Routing.generate('api_get_sizes_meal_type', {
          context: 'dropdown',
          id: value.id,
        })

        this.$http.get(url).then(
          response => {
            this.sizes = response.data
            this.loading--
          },
          response => {
            this.handleAjaxError(response)
            this.loading--
          }
        )
      }
    },
    getStatuses() {
      this.loading++

      let url = Routing.generate('api_get_tags', {
        type: 'ecommerce_bag_item_status',
        context: 'dropdown',
      })

      this.$http.get(url).then(
        response => {
          this.statuses = response.data
          this.loading--
        },
        response => {
          this.handleAjaxError(response)
          this.loading--
        }
      )
    },
    trans(name) {
      return Translator.trans(name)
    },
    saveNewBagItem() {
      let url = Routing.generate('api_post_bagitem_add_to_bag', { id: this.bag })

      Vue.http
        .post(url, {
          data: this.bagItem,
        })
        .then(
          () => {
            this.form.options.errors = {}
            toastr.success(Translator.trans('form.updated'))
            this.$emit('bag-item-saved')
          },
          response => {
            this.handleAjaxError(response, this.form.options)
            this.$emit('bag-item-save-failed')
          }
        )
    },
  },
  saveBagItem() {},
  getBagItem() {},
}
</script>

<style>
.modal-backdrop.show {
    opacity: 0.5;
}

div.modal .modal-dialog {
    width: 1200px !important;
}
</style>
